import React from 'react';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import H6 from '@base/H6/H6';
import Button from '@base/Button/Button';
import Paper from '@base/Paper/Paper';
import Practice from '@icon/Syllabus/Practice';

const Wrapper = styled(Paper)`
  height: 70px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
  padding: 0 ${Spacings.SPACING_6B};
`;

const StyH6 = styled(H6)`
  margin-left: 10px;
  line-height: 18px;
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyButton = styled(Button)`
  font-size: 10px;
  border-radius: ${Spacings.SPACING_1B};
  color: var(--color-base-1);
`;

interface IPracticeCardProps {
  onPracticeStart: () => void;
}

const PracticeCard: React.FC<IPracticeCardProps> = ({ onPracticeStart }) => {
  return (
    <Wrapper data-testid="practice-card-wrapper">
      <InfoWrapper>
        <Practice size={Spacings.SPACING_8B} />
        <StyH6>Practice</StyH6>
      </InfoWrapper>
      <StyButton
        // @ts-ignore
        label="START"
        color="black"
        maxHeight="xs"
        width="90px"
        onClick={onPracticeStart}
      />
    </Wrapper>
  );
};

export default PracticeCard;
